import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import type { Asset } from '@/types';
import selectors from '@/ui/flux/selectors';

function useGetAssetDisableBlockReason() {
  const assetCannotBeDisabledReason = useSelector(
    selectors.assetManagement.assetCannotBeDisabledReason,
  );

  return useCallback(
    (asset: Asset) => assetCannotBeDisabledReason[asset.name],
    [assetCannotBeDisabledReason],
  );
}

export default useGetAssetDisableBlockReason;
